import React, { useState } from 'react';
import { LoadingAnimation } from 'ui-builder';
import useDataLoader from 'data-loader';
import {
  RoadmapPreviewResponse,
  useRoadmapPreviewService,
} from './roadmapPreviewService';
import Layout from './Layout';

export interface RoadmapPreviewProps {
  projectId: number;
  taskName: string;
  roadmapDescription: string | null | undefined;
  taskDescription: string | null | undefined;
}

export function RoadmapPreview(props: RoadmapPreviewProps) {
  const [preview, setPreview] = useState<RoadmapPreviewResponse>();
  const previewService = useRoadmapPreviewService();

  useDataLoader(
    async () => {
      return previewService.getRoadmapPreview(
        props.projectId,
        props.taskName,
        props.roadmapDescription,
        props.taskDescription
      );
    },
    (response: RoadmapPreviewResponse) => {
      setPreview(response);
    }
  );

  if (preview) {
    return <Layout preview={preview} />;
  } else {
    return <LoadingAnimation />;
  }
}
